<template>
  <h1>Hier komen de rechten</h1>
</template>
<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {
    
    };
  },
};
</script>

